import React from 'react';
import NavBar from 'src/presentation/components/organisms/NavBar';
import Gallery from 'src/presentation/components/organisms/Gallery';
import { View } from 'react-native';
import { useRoute } from '@react-navigation/native';
import type { RouteProp } from '@react-navigation/native';
import type { GalleryStackParamList } from 'src/presentation/navigation/types/NavigationTypes';
import EmptyState from 'src/presentation/components/molecules/EmptyState';
import Translations from 'src/core/utils/Translations';
import Colors from 'src/core/utils/Colors';
import type Constants from 'src/core/utils/Constants';
import { useRootGalleryPageFromRoute } from 'src/presentation/hooks/useRootGalleryFromRoute';

function RootGalleryScreen() {
	const route = useRoute<RouteProp<GalleryStackParamList, typeof Constants.screenRootGalleryPage>>();
	const params = route.params;
	const galleryPage = useRootGalleryPageFromRoute(params);

	return (
		<View style={{ flex: 1, backgroundColor: Colors.white }}>
			<NavBar
				backBtn={true}
				bgcolor={Colors.primary}
				centerTitle={true}
				color={Colors.black}
				editBtn={false}
				title={galleryPage?.name ?? params.name ?? ''}
			/>
			{galleryPage ? (
				<Gallery data={galleryPage} />
			) : (
				<EmptyState icon="images-outline" message={Translations.textNoGalleryData} />
			)}
		</View>
	);
}

export default RootGalleryScreen;
